<div class="main-header-wrapper" [ngClass]="isLoggedIn ? 'logged-in' : ''">
    <div class="main-header-inner-wrapper">
        <div class="left-col">
            <div class="col-inner-wrapper">
               <ng-container *ngIf="!isMenuHide">
                   <div class="menu-burger" *ngIf="showAt$l && isLoggedIn" (click)="openSideNav()">
                       <img src="assets/icons/icon-menu-burger.svg" />
                   </div>
               </ng-container>
                <div class="logo-wrapper">
                    <img src="assets/images/avenir-energy-logo-primary.svg" (click)="goToHomePage()"/>
                </div>
                <div class="menu-links" *ngIf="isLoggedIn && !hideAt$l;">
                    <!-- for logged in users only -->
                        @for(menuItem of desktopLoggedInMenuItems; track $index;) {
                            <div [ngClass]="[selectedTab() == $index ? 'active-tab':'inactive-tab', selectedTab() == 10 ? 'no-active-tab': '' ]" [attr.data-text]="menuItem.label" (click)="goToPage(menuItem.url, $event, true, $index)" *ngIf="menuItem.inDesktop" class="link"><span>{{ menuItem.label }}</span></div>
                        }
                </div>
            </div>
        </div>
        <div class="right-col">
            <div class="col-inner-wrapper" *ngIf="!isMenuHide">
                <ng-container *ngIf="isLoggedIn && !hideAt$l;">
                    <avenir-button [theme]="BUTTON_THEME.WHITE" [label]="contactUsLabel" 
                        (onClick)="openContactUsSite()">
                    </avenir-button>
                    <avenir-button [theme]="BUTTON_THEME.BLUE" [label]="orderPropaneLabel" 
                        (onClick)="openOrderPropaneSite()">
                    </avenir-button>
                </ng-container>
                <ng-container *ngIf="!isLoggedIn; else loggedInOtherMenu">
                    <!-- not login -->
                    <!-- <div class="search">
                        <img src="assets/icons/search.svg" />
                    </div> -->
                    <div class="login-wrapper">
                        @if(isAtSignUpPage){
                            <button class="my-account-btn" (click)="goToPage('account/login/residential', $event, true, 10)" i18n="@@backToLogin">
                                Back to Login
                            </button>
                        }
                        <!-- @else {
                            <button class="my-account-btn" (click)="goToPage('/open-account', $event, true, 10)">
                                <ng-container i18n="@@openAnAccount">Open an Account</ng-container>
                            </button>
                        } -->
                        <!-- <div ngbDropdown class="d-inline-block">
                            <button class="my-account-btn" id="dropdownBasic1" ngbDropdownToggle>
                                My Account
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <div ngClass="login-dropdown-item" ngbDropdownItem>
                                    <div class="top">
                                        <span class="login-link" (click)="goToPage('account/login/residential', $event, true, 10)">Login to your account</span>
                                        <span class="register-link">Register</span>
                                    </div>
                                    <div class="bottom">
                                        <div class="outer">
                                            <span class="link" (click)="goToPage('/open-account', $event, true, 10)" i18n="@@openAnAccountWithAvenirEnergy">Open an account with Avenir Energy</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </ng-container>
                <ng-template #loggedInOtherMenu>
                    <!-- <a class="request-btn btn" *ngIf="!hideAt$l" (click)="goToRequestServicePage()" i18n="@@requestService">Request Service</a> -->
                    <!-- <a class="order-propane-btn btn" *ngIf="!hideAt$l" (click)="goToOrderPropanePage()" i18n="@@orderPropane">Order Propane</a> -->
                    <!-- <a class="order-propane-btn btn" *ngIf="!hideAt$l" (click)="goToOrderPropanePage()" i18n="@@orderPropane">
                        <img src="assets/icons/order-propane-flame.svg" />
                        Order Propane
                      </a> -->
                      <!-- main-header.component.html -->
                    <!-- <a class="order-propane-btn btn" *ngIf="!hideAt$l" (click)="goToOrderPropanePage()">
                        <img src="assets/icons/order-propane-flame.svg" />
                        <ng-container i18n="@@orderPropane">Order Propane</ng-container>
                    </a> -->
                    
                    <!-- Modal for showing unavailable message -->
                    <div *ngIf="isModalVisible" class="modal">
                        <div class="modal-content">
                            <img class="modal-icon" src="assets/icons/propane-safety.svg" />
                            <p>Propane ordering is currently unavailable through the Customer Portal. Please contact your local branch to request delivery</p>
                            
                            <hr class="divider" />
                          
                            <button class="ok-btn" (click)="closeModal()">OK</button>
                        </div>                          
                    </div>

                    <div *ngIf="isServiceModalVisible" class="modal">
                        <div class="modal-content">
                            <img class="modal-icon" src="assets/icons/propane-safety.svg" />
                            <p>Service Request is currently unavailable through the Customer Portal. Please contact your local branch to request delivery</p>
                            
                            <hr class="divider" />
                          
                            <button class="ok-btn" (click)="closeModal()">OK</button>
                        </div>                          
                    </div>

                    <div class="profile">
                        <div class="profile-circle">
                            @if(customerId) {
                                <avenir-header-user-menu [customerId]="customerId"></avenir-header-user-menu>
                            }
                        </div>
                      </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
